import React from 'react';
import {
  HeroSection,
  MapSection,
  AboutSection,
  WhyNowSection,
  ProductSection,
  EconomyNewSection,
  MarketingSection,
  WhyUsSection,
  StartSection,
  SucsessSection,
  ConditionsNewSection,
  PartnersSection,
  FinalSection,
  /* CompanySection,
  GeographySection,
  EconomySection,
  ConditionsSection, */
  // FloatingCta,
  FranchiseAside,
  FRANCHISE_SECTION_IDS,
  useScrollReveal,
  useFranchiseScrollSpy,
} from './franchise';
// import { openFranchiseFinmodelForm } from './franchise/franchiseConstants';

export default function FranchisePage() {
  const activeSectionId = useFranchiseScrollSpy(FRANCHISE_SECTION_IDS);

  useScrollReveal();

  return (
    <>
      <FranchiseAside activeSectionId={activeSectionId} />
      <div className="wrapper franchise-page-wrapper d-flex flex-column flex-row-fluid mt-5 mt-lg-10">
        <div className="content flex-column-fluid position-relative">
          <div className="franchise-page">
            <HeroSection />
            <MapSection />
            <AboutSection />
            <WhyNowSection />
            <ProductSection />
            <EconomyNewSection />
            <MarketingSection />
            <WhyUsSection />
            <StartSection />
            <SucsessSection />
            <ConditionsNewSection />
            <PartnersSection />
            <FinalSection />
            {/* <CompanySection />
            <GeographySection />
            <EconomySection />
            <ConditionsSection /> */}
          </div>
        </div>
      </div>

      {/* <FloatingCta onClick={openFranchiseFinmodelForm()} activeSectionId={activeSectionId} /> */}
    </>
  );
}
